import { z } from 'zod';

import type { TFunction } from 'i18next';

// `Form.Select` writes `null` when cleared, so a required select cannot be `z.string().min(1)`
// — that reports zod's own «expected string, received null» instead of the translated message.
export const requiredSelect = (t: TFunction) =>
  z
    .string()
    .nullable()
    .refine((value) => !!value, { message: t('validation_required') });
